<template>
  <v-container fluid>
    <v-row justify="center"
           class="mb-2"
           no-gutters>
      <v-col cols="11">
        <v-form>
          <v-row>
            <v-col cols="2" class="py-0">
              <z-source-selector  label="仓库名称"
                                 hide-details="auto"
                                  multiple
                                 v-model="queryRequest.warehouseId"
                                 source="WarehouseSelector"/>
            </v-col>
            <v-col cols="2" class="py-0">
              <v-text-field prepend-inner-icon="search" clearable label="物料产品编码"
                            hide-details="auto"
                            @keydown.enter="queryResetPage"
                            v-model="queryRequest.materielProdNo"/>
            </v-col>
            <v-col cols="2" class="py-0">
              <v-text-field prepend-inner-icon="search" clearable label="物料名称"
                            @keydown.enter="queryResetPage"
                            hide-details="auto"
                            v-model="queryRequest.materielName"/>
            </v-col>
            <v-col cols="2" class="py-0">
              <v-text-field prepend-inner-icon="search" clearable label="品牌"
                            @keydown.enter="queryResetPage"
                            hide-details="auto"
                            v-model="queryRequest.materielBrand"/>
            </v-col>
            <v-col cols="2" class="py-0">
              <v-text-field prepend-inner-icon="search" clearable label="型号"
                            @keydown.enter="queryResetPage"
                            hide-details="auto"
                            v-model="queryRequest.materielModel"/>
            </v-col>
            <v-col cols="2" class="py-0">
              <v-text-field prepend-inner-icon="search" clearable label="规格1"
                            @keydown.enter="queryResetPage"
                            hide-details="auto"
                            v-model="queryRequest.specification"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="2" class="pb-0">
              <v-text-field
                  @keydown.enter="queryResetPage"
                  clearable
                  v-model="queryRequest.storageNo"
                  label="入库单号"
                  hide-details="auto"
                  prepend-inner-icon="search"/>
            </v-col>
            <v-col cols="2" class="pb-0">
              <v-text-field
                  @keydown.enter="queryResetPage"
                  clearable
                  v-model="queryRequest.factSerialNo"
                  label="出厂序列号"
                  hide-details="auto"
                  prepend-inner-icon="search"/>
            </v-col>
            <v-col cols="2" class="pb-0">
              <z-source-selector
                  v-model="queryRequest.state"
                  hide-details="auto"
                  param="MATERIAL_STATUS"
                  label="状态"/>
            </v-col>
            <v-col cols="2" class="pb-0">
              <v-text-field prepend-inner-icon="search" clearable label="品类"
                            hide-details="auto"
                            @keydown.enter="queryResetPage"
                            v-model="queryRequest.category"/>
            </v-col>
            <v-col cols="1" class="pb-0">
              <v-text-field clearable label="子类"
                            hide-details="auto"
                            @keydown.enter="queryResetPage"
                            v-model="queryRequest.subType"/>
            </v-col>
            <v-col cols="1" class="pb-0">
              <v-switch
                  v-model="queryRequest.supplies"
                  class="ma-2"
                  @keydown.enter="queryResetPage"
                  label="耗材"/>
            </v-col>
            <v-col cols="2" class="pb-0">
              <v-text-field prepend-inner-icon="search" clearable label="备件适用部位"
                            @keydown.enter="queryResetPage"
                            hide-details="auto"
                            v-model="queryRequest.accApplicableParts"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="pb-0 d-flex justify-end align-self-center">
              <v-badge
                  :content="querySelected"
                  :value="querySelected!=0"
                  color="green"
                  overlap
              >
                <v-btn small
                       color="primary"
                       @click="queryResetPage">
                  搜索
                  <v-icon right>mdi-magnify</v-icon>
                </v-btn>
              </v-badge>
              <v-btn small color="primary" class="ml-2"
                     @click="resetQuery">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn small v-on="on"
                         icon
                         class="ml-2"
                         color="primary"
                         @click="extend">
                    <v-icon v-if="!seniorQueryFlag" large>mdi-arrow-down-drop-circle</v-icon>
                    <v-icon v-else large>mdi-arrow-up-drop-circle</v-icon>
                  </v-btn>
                </template>
                <span>高级搜索按钮</span>
              </v-tooltip>
              <v-btn v-if="!oaFlag" small color="primary" class="ml-2" @click="report">
                一键导出
              </v-btn>
            </v-col>
          </v-row>
          <v-expand-transition>
            <div v-show="seniorQueryFlag">
              <v-row>
                <v-col cols="3" class="pb-0 d-flex justify-space-between align-self-end">
                  <span style="width: 110px;" class="d-flex align-center">  新：</span>
                  <v-text-field dense clearable
                                @keydown.enter="queryResetPage"
                                v-model="queryRequest.brandNewMin"/>
                  <span class="d-flex align-center">~</span>
                  <v-text-field dense clearable
                                @keydown.enter="queryResetPage"
                                v-model="queryRequest.brandNewMax"/>
                </v-col>
                <v-col cols="3" class="pb-0 d-flex justify-space-between align-self-end">
                                    <span style="width: 110px;"
                                          class="d-flex align-center">
                                        好：
                                    </span>
                  <v-text-field dense clearable
                                @keydown.enter="queryResetPage"
                                v-model="queryRequest.notNewMin"/>
                  <span class="d-flex align-center">~</span>
                  <v-text-field dense clearable
                                @keydown.enter="queryResetPage"
                                v-model="queryRequest.notNewMax"/>
                </v-col>
                <v-col cols="3" class="pb-0 d-flex justify-space-between align-self-end">
                  <span style="width: 110px;" class="d-flex align-center"> 坏： </span>
                  <v-text-field dense clearable
                                @keydown.enter="queryResetPage"
                                v-model="queryRequest.badMin"/>
                  <span class="d-flex align-center">~</span>
                  <v-text-field dense clearable
                                @keydown.enter="queryResetPage"
                                v-model="queryRequest.badMax"/>
                </v-col>
                <v-col cols="3" class="pb-0 d-flex justify-space-between align-self-end">
                                    <span style="width: 110px;"
                                          class="d-flex align-center">
                                        待测：
                                    </span>
                  <v-text-field dense clearable
                                @keydown.enter="queryResetPage"
                                v-model="queryRequest.waitTestMin"/>
                  <span class="d-flex align-center">~</span>
                  <v-text-field dense clearable
                                @keydown.enter="queryResetPage"
                                v-model="queryRequest.waitTestMax"/>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3" class="d-flex justify-space-between">
                                    <span style="width: 160px;"
                                          class="d-flex align-center">
                                        无法修复：
                                    </span>
                  <v-text-field dense clearable
                                @keydown.enter="queryResetPage"
                                v-model="queryRequest.beyondRepairMin"/>
                  <span class="d-flex align-center">~</span>
                  <v-text-field dense clearable
                                @keydown.enter="queryResetPage"
                                v-model="queryRequest.beyondRepairMax"/>
                </v-col>
                <v-col cols="3" class="d-flex justify-space-between">
                                    <span style="width: 110px;"
                                          class="d-flex align-center">
                                        已报废：
                                    </span>
                  <v-text-field dense clearable
                                @keydown.enter="queryResetPage"
                                v-model="queryRequest.scrappedMin"/>
                  <span class="d-flex align-center">~</span>
                  <v-text-field dense clearable
                                @keydown.enter="queryResetPage"
                                v-model="queryRequest.scrappedMax"/>
                </v-col>

                <v-col cols="3" class="d-flex justify-space-between">
                                    <span style="width: 110px;"
                                          class="d-flex align-center">
                                        总库存：
                                    </span>
                  <v-text-field dense clearable
                                @keydown.enter="queryResetPage"
                                v-model="queryRequest.stockMin"/>
                  <span class="d-flex align-center">~</span>
                  <v-text-field dense clearable
                                @keydown.enter="queryResetPage"
                                v-model="queryRequest.stockMax"/>
                </v-col>
                <v-col cols="2" class="d-flex justify-space-between">
                                    <span style="width: 110px;"
                                          class="d-flex align-center">
                                        已锁定：
                                    </span>
                  <v-text-field dense clearable
                                @keydown.enter="queryResetPage"
                                v-model="queryRequest.lockedMin"/>
                  <span class="d-flex align-center">~</span>
                  <v-text-field dense clearable
                                @keydown.enter="queryResetPage"
                                v-model="queryRequest.lockedMax"/>
                </v-col>

              </v-row>
            </div>
          </v-expand-transition>
        </v-form>
      </v-col>
    </v-row>

    <v-row class="d-flex justify-center">
      <v-col :sm="11" :xs="12" cols="8">
        <v-data-table
            :headers="headers"
            :items="list"
            disable-sort
            :options.sync="options"
            :page.sync="queryRequest.pagedQueryInfo.index"
            :server-items-length="total"
            :loading="loading"
            :single-expand="true"
            item-key="index"
            show-expand
            :footer-props="footerOptions"
            :search="search">
          <template v-slot:item.specification="{ item }">
            {{
              (item.specification ? item.specification : '') + (item.specification2 ? '-' + item.specification2 : '')
              + (item.specification3 ? '-' + item.specification3 : '') + (item.specification4 ? '-' + item.specification4 : '')
            }}
          </template>
          <template v-slot:item.brandNewCount="{ item }">
            <div v-if="oaFlag">
              {{ item.brandNewCount }}
            </div>
            <a v-else @click="toAccountPage(item.warehouseId,item.materielProdNo,item.brandNewCount,'01')">
              {{ item.brandNewCount }}
            </a>
          </template>
          <template v-slot:item.notNewCount="{ item }">
            <div v-if="oaFlag">
              {{ item.notNewCount }}
            </div>
            <a v-else @click="toAccountPage(item.warehouseId,item.materielProdNo,item.notNewCount,'02')">
              {{ item.notNewCount }}
            </a>
          </template>
          <template v-slot:item.waitTestCount="{ item }">
            <div v-if="oaFlag">
              {{ item.waitTestCount }}
            </div>
            <a v-else @click="toAccountPage(item.warehouseId,item.materielProdNo,item.waitTestCount,'03')">
              {{ item.waitTestCount }}
            </a>
          </template>
          <template v-slot:item.badCount="{ item }">
            <div v-if="oaFlag">
              {{ item.badCount }}
            </div>
            <a v-else @click="toAccountPage(item.warehouseId,item.materielProdNo,item.badCount,'06')">
              {{ item.badCount }}
            </a>
          </template>
          <template v-slot:item.beyondRepairCount="{ item }">
            <div v-if="oaFlag">
              {{ item.beyondRepairCount }}
            </div>
            <a v-else @click="toAccountPage(item.warehouseId,item.materielProdNo,item.beyondRepairCount,'04')">
              {{ item.beyondRepairCount }}
            </a>
          </template>
          <template v-slot:item.scrappedCount="{ item }">
            <div v-if="oaFlag">
              {{ item.scrappedCount }}
            </div>
            <a v-else @click="toAccountPage(item.warehouseId,item.materielProdNo,item.scrappedCount,'05')">
              {{ item.scrappedCount }}
            </a>
          </template>
          <template v-slot:item.stockCount="{ item }">
            <a @click="toAccountPage(item.warehouseId,item.materielProdNo,item.stockCount,'')">{{ item.stockCount }}</a>
          </template>
          <template v-slot:item.lockedCount="{ item }">
            <a @click="toAccountPage(item.warehouseId,item.materielProdNo,item.lockedCount,'07')">{{
                item.lockedCount
              }}</a>
          </template>

          <template v-slot:expanded-item="{ headers,item }">
            <td :colspan="headers.length">
              <div style="padding:10px 0;">
                <span>需要退库</span>：
                <span>{{ item.withdrawalFlag ? '是' : '否' }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>是否耗材</span>：
                <span>{{ item.supplies ? '是' : '否' }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>物料产品编码</span>：
                <span>{{ item.materielProdNo }}</span>
              </div>
              <div style="padding:10px 0;"
                   v-if="item.materialAttachedInfo && item.materialAttachedInfo.picInfos">
                <span>图片信息</span>：
                <v-row style="width: 98%;">
                  <v-col cols="4"
                         v-for="(itemImg,index) in item.materialAttachedInfo.picInfos"
                         :key="index">
                    <v-img :src="itemImg"
                           aspect-ratio="1.7"
                           contain></v-img>
                  </v-col>
                </v-row>
              </div>
            </td>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-dialog v-model="exportLoading"
              fullscreen
              overlay-color="white">
      <div
          style="width: 100%;height: 100%;background-color: rgba(255,255,255,0.5);display: flex;align-items: center;justify-content: center">
        <div style="text-align: center">
          <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
          >
          </v-progress-circular>
          <br/>
          <p style="margin-top: 10px; color: blue">报表生成中,请稍等...</p>
        </div>
      </div>
    </v-dialog>
  </v-container>


</template>

<script>
import {dataChangedCountMixin,dataCatchMixin} from "@/mixin"
import {pageQuery} from "@/api/InventoryManagement";
import {reportExport} from "@/api/InventoryManagement";
import {mapGetters} from "vuex"

// import {reportExportProgress} from "@/api/InventoryManagement";

export default {
  name: "InventoryManagement",
  mixins: [dataChangedCountMixin,dataCatchMixin],
  computed: {
    ...mapGetters([
      "oaFlag"
    ]),
  },
  data() {
    return {
      footerOptions: {
        itemsPerPageOptions: [10, 50, 100, 200]
      },
      loading: false,
      exportLoading: false,
      seniorQueryFlag: false,
      //请求参数
      queryRequest: {
        pagedQueryInfo: {
          index: 1,
          pageSize: 10
        },
        warehouseId: [],
        materielName: "",
        materielBrand: "",
        materielModel: "",
        specification: "",
        specification2: "",
        specification3: "",
        specification4: "",
        materielId: "",
        category: "",
        subType: "",
        materielProdNo: "",
        accApplicableParts: "",
        unit: "",
        brandNewMin: undefined,
        brandNewMax: undefined,
        notNewMin: undefined,
        notNewMax: undefined,
        waitTestMin: undefined,
        waitTestMax: undefined,
        badMin: undefined,
        badMax: undefined,
        beyondRepairMin: undefined,
        beyondRepairMax: undefined,
        scrappedMin: undefined,
        scrappedMax: undefined,
        stockMin: undefined,
        stockMax: undefined,
        lockedMin: undefined,
        lockedMax: undefined,
        withdrawalFlag: undefined,
        supplies: undefined,
        factSerialNo: '',
        storageNo: '',
      },
      list: [],
      total: 0,
      headers: [
        {text: '仓库', value: 'warehouseName', align: 'center',},
        {text: '物料名称', value: 'materielName', align: 'center',},
        {text: '品牌', value: 'materielBrand', align: 'center',},
        {text: '型号', value: 'materielModel', align: 'center',},
        {text: '规格', value: 'specification', align: 'center',},
        {text: '物料品类', value: 'category', align: 'center',},
        {text: '物料子类', value: 'subType', align: 'center',},
        {text: '计量单位', value: 'unit', align: 'center',},
        {text: '新', value: 'brandNewCount', align: 'center',},
        {text: '好', value: 'notNewCount', align: 'center',},
        {text: '待测', value: 'waitTestCount', align: 'center',},
        {text: '坏', value: 'badCount', align: 'center',},
        {text: '无法修复', value: 'beyondRepairCount', align: 'center',},
        {text: '已报废', value: 'scrappedCount', align: 'center',},
        {text: '总库存', value: 'stockCount', align: 'center',},
        {text: '已锁定', value: 'lockedCount', align: 'center',},
        {text: ' ', value: 'data-table-expand', align: 'center',},
      ],
      options: {},
      search: '',
    }
  },
  watch: {
    options: {
      handler(val) {
        console.log(val.itemsPerPage, "1111111111111")
        console.log(val.page, "1111111111111")
        if (val.itemsPerPage == -1) {
          this.queryRequest.pagedQueryInfo.index = 1
          this.queryRequest.pagedQueryInfo.pageSize = 999999
        } else if (!!val.page && !!val.itemsPerPage) {
          this.queryRequest.pagedQueryInfo.index = val.page
          this.queryRequest.pagedQueryInfo.pageSize = val.itemsPerPage
        }
        this.handleQuery()
      }
    }
  },
  methods: {
    extend() {
      this.seniorQueryFlag = !this.seniorQueryFlag;
    },
    //查询
    queryResetPage() {
      this.queryRequest.pagedQueryInfo.index = 1;
      this.handleQuery();
    },
    //重置
    resetQuery() {
      Object.assign(this.$data, this.$options.data());
    },
    handleQuery() {
      this.loading = true;
      pageQuery(this.queryRequest).then(res => {
        this.list = res.list;
        this.total = res.total;
        this.loading = false
      }).catch(err => {
        this.loading = false
      })
    },
    //一键导出
    report() {
      this.exportLoading = true;
      reportExport(this.queryRequest).then(res => {
        this.$router.push({
          path: '/export-report-queue?id=' + res
        });
        // downloadReportExcel(res);
        this.exportLoading = false;
      }).catch(err => {
        this.exportLoading = false;
      });
      // var _this=this;
      // _this.timer =  setInterval(function (){
      //   reportExportProgress({}).then(res=>{
      //     console.log(res,'333333')
      //     if(_this.exportLoading){
      //       _this.exportProgress = res;
      //     }else {
      //       clearInterval(_this.timer)
      //     }
      //   }).catch(err=>{
      //     clearInterval(_thiss.timer);
      //     _this.exportLoading = false;
      //   })
      // },1000);
    },
    //跳转页面
    toAccountPage(warehouseId, prodNo, count, state) {
      if (count > 0) {
        this.$router.push({
          path: '/account-management?warehouseId=' + warehouseId +
              '&materielProdNo=' + prodNo + '&storageNo=' + this.queryRequest.storageNo
              + '&state=' + state
              + '&factSerialNo=' + this.queryRequest.factSerialNo
        });
        this.$store.dispatch('setCurretTitle', '物料台账管理');

      } else {
        return false;
      }
    },
    // //规则
    // dataRules(min, max) {
    //     var rules =
    //         [
    //             () => !(!!min && !!max && min>max) || '最小值大于最大值~'
    //         ];
    //     return rules;
    // },
  },
  created() {
    this.$store.dispatch('setCurretTitle', '库存管理');
  },
  mounted() {
  },
}
</script>

<style scoped>

</style>
